import type { Component } from 'vue'

const wnd: any = window as any
export type ModalType = 'modal-right-full-page' | 'modal-bottom-dynamic' | 'modal-center-screen'
export interface NewModal {
  type: ModalType
  name: string
  component: Component
  index?: number

  props: Record<string, any>
  allowedClickOutSide?: boolean
}
export function addNewModal(modal: NewModal) {
  wnd.addNewModal(modal)
}

export function triggerLoading(show: boolean) {
  wnd.triggerLoading(show)
}

